module.exports = __webpack_public_path__ + "static/Icon1-25e0f4a394a63acf80af1bb6a3a56d16.svg";